<template>
<div>
  <div class="customer-pix col-md-12" v-if="data.pix && data.status !== 'Paga' && data.currentStep === 'Aprovado - Pagamentos Pendentes'">
    <div class="row">
      <div class="col-md-12">
        <h2>PIX</h2>
        <div class="content-customer-pix">
          <div class="status-bar">
            <div>Pedido aguardando confirmação</div>
            <div>Expira em {{ time }}</div>
          </div>
          <div class="menu-pix">
            <button @click.prevent="togglePixDropdown"><i class="icon-more-squares-vertical-filled"></i></button>
            <div class="menu-pix-options" :class="{'open': statePixMenu}">
              <ul v-show="statePixMenu">
                <li>
                  <button
                    title="Copiar código PIX"
                    v-clipboard:copy="data.pixCodigoQrCode"
                    v-clipboard:success="onCopyPix"
                    v-clipboard:error="onError"
                    class="primary"
                    :class="!showCopyPixCode ? 'disabled' : ''"
                    :disabled="!showCopyPixCode"
                  >
                    Copiar código PIX
                  </button>
                </li>
                <li>
                  <button
                    title="Regerar código PIX"
                    @click="regeneratePixCode"
                    :class="!showRegeneratePixCode ? 'disabled' : ''"
                    :disabled="!showRegeneratePixCode"
                  >
                    <div v-if="!loading" role="status">
                      Enviar novo código
                    </div>
                    <div v-else>
                      Carregando...
                    </div>
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="customer-pix col-md-12" v-else-if="orderTransactionStatus !== 'Aprovado - Pagamentos Pendentes' && data.firstPaymentRequired">
    <div class="row">
      <div class="col-md-12">
        <h2>PIX</h2>
        <div class="content-customer-pix">
          <div class="status-bar">
            <div style="color: #1C56E0; font-weight: normal">Aguardando aprovação do atendimento</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Button from '../button/Button.vue'
export default {
  components: { Button },
  data () {
    return {
      data: {},
      textDay: null,
      textHour: null,
      textMinute: '00',
      textSecond: '00',
      time: '',
      clearPixCodeTime: null,
      showRegeneratePixCode: false,
      showCopyPixCode: true,
      loading: false,
      statePixMenu: false
    }
  },
  mounted () {
    this.getCustomerPixStatus()
    document.addEventListener('click', this.closePixDropdown)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.closePixDropdown)
  },
  methods: {
    togglePixDropdown (e) {
      this.statePixMenu = !this.statePixMenu
    },
    closePixDropdown (e) {
      if (!this.$el.contains(e.target)) {
        if (!this.loading) {
          this.statePixMenu = false
        }
      }
    },
    getCustomerPixStatus () {
      this.$http.get('api/order-validation/' + this.$route.params.txid + '/customer-pix-status')
        .then(function (res) {
          this.data = res.data
          this.$emit('emit-pix-data', this.data)

          if (this.data.paymentType === 'PIX') {
            this.clearPixCodeTime = setInterval(() => {
              this.pixCodeTimeExpiresCountdown()

              if (new Date() > new Date(this.data.pixDateExpire)) {
                clearInterval(this.clearPixCodeTime)
              }
            }, 1000)
          }
        })
        .catch(function (res) {
          console.error('Error')
          console.error(res)
        })
    },
    pixCodeTimeExpiresCountdown () {
      var strTime = ''

      if (new Date() > new Date(this.data.pixDateExpire)) {
        this.time = '00:00:00'
        this.showRegeneratePixCode = true
        return this.time
      }

      const dtExp = new Date(this.data.pixDateExpire)
      const countDate = dtExp.getTime()
      const now = new Date().getTime()
      const gap = countDate - now

      const second = 1000
      const minute = second * 60
      const hour = minute * 60
      const day = hour * 24

      this.textDay = Math.floor(gap / day)
      this.textHour = Math.floor((gap % day) / hour)
      this.textMinute = Math.floor((gap % hour) / minute)
      this.textSecond = Math.floor((gap % minute) / second)

      // if (this.textDay > 0) {
      //   if (strTime !== '') strTime += ', '
      //   strTime += (this.textDay > 1) ? this.textDay + ' dias' : '1 dia'
      // }
      // if (this.textHour > 0) {
      //   if (strTime !== '') strTime += ', '
      //   strTime += (this.textHour > 1) ? this.textHour + ' horas' : '1 hora'
      // }
      // if (this.textMinute > 0) {
      //   if (strTime !== '') strTime += ', '
      //   strTime += (this.textMinute > 1) ? this.textMinute + ' min' : '1 min'
      // }

      strTime += this.textHour < 10 ? `0${this.textHour}:` : `${this.textHour}:`
      strTime += this.textMinute < 10 ? `0${this.textMinute}:` : `${this.textMinute}:`
      strTime += this.textSecond < 10 ? `0${this.textSecond}` : this.textSecond

      this.time = strTime
    },
    onCopyPix: function (e) {
      alert(this.data.pixCodigoQrCode + ' copiado com sucesso')
    },
    onError: function (e) {
      alert('falha na cópia')
    },
    regeneratePixCode () {
      this.showCopyPixCode = false
      this.loading = true
      this.$http.get('pix/recreate/' + this.$route.params.txid + '/1/0') // review request method
        .then(function (res) {
          this.getCustomerPixStatus()
          this.loading = false
          this.showCopyPixCode = true
          this.$bvToast.toast('Código PIX gerado com sucesso', {
            autoHideDelay: 5000,
            variant: 'success'
          })
        })
        .catch(function (res) {
          console.error('Error')
          console.error(res)
          console.log(JSON.stringify(res.body.message, null, 2))
          this.loading = false
          this.showCopyPixCode = true

          if (res.body.message === 'Cannot regenerate pix - order expired') {
            this.$bvToast.toast('Pedido expirado, não é possível gerar PIX', {
              autoHideDelay: 5000,
              variant: 'danger'
            })
          } else {
            this.$bvToast.toast('Erro ao gerar código PIX', {
              autoHideDelay: 5000,
              variant: 'danger'
            })
          }
        })
    }
  },
  props: ['orderTransactionStatus']
}
</script>

<style lang="scss" scoped>
  .customer-pix {
    margin-bottom: 32px;
    .row {
      div {
        .content-customer-pix {
          display: flex;
          align-items: center;
          .status-bar {
            width: calc(100% - 40px);
            height: 32px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-right: 8px;
            border-radius: 10px;
            padding: 16px;
            background: rgba(66, 133, 244, 0.1);
            div {
              &:first-child {
                color: #4285F4;
              }
              &:last-child {
                color: #F09B1B;
                font-weight: 700;
              }
            }
          }
          .menu-pix {
            .menu-pix-options {
              position: absolute;
              display: none;
              right: 15px;
              margin-top: 10px;
              border: 1px solid #F9F9F9;
              border-radius: 4px;
              box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.15);
              background-color: #FFFFFF;
              z-index: 10;
              &.open {
                display: block;
              }
              &::after {
                content: "";
                position: absolute;
                bottom: 100%;
                right: 11px;
                margin-left: -5px;
                border-width: 5px;
                border-style: solid;
                border-color: transparent transparent #FFFFFF transparent;
              }
              ul {
                padding: 8px 0;
                margin: 0;
                li {
                  padding: 8px 16px;
                  list-style: none;
                  border-bottom: 1px solid #F9F9F9;
                  &:last-child {
                    border: none;
                  }
                  button {
                    display: contents;
                    color: #000000;
                    text-align: left;
                    padding: 0;
                    margin: 0;
                    border: none;
                    background-color: transparent;
                    &.primary {
                      color: #4285F4;
                    }
                    &.disabled {
                      cursor: not-allowed;
                      color: rgba(0, 0, 0, 0.25);
                    }
                  }
                }
              }
            }
          }
          .copy-pix-button {
            width: 100px;
            float: right;
            button {
              width: 24px;
              height: 24px;
              float: right;
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 5px;
              margin-top: -4px;
              margin-left: 8px;
              padding: 0px;
              border: none;
              background: rgba(66, 133, 244, 0.2);
              color: #4285F4;
              outline: none;
            }
            .button-text {
              float: right;
              line-height: 1.4em;
              color: rgba(66, 133, 244, 0.75);
              margin-right: 4px;
            }
            .pix-loading {
              margin-left: 2px;
              color: #4285F4;
              font-size: 5px;
            }
          }
          button {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 32px;
            height: 32px;
            border-radius: 5px;
            border: none;
            background-color: #1c56e0;
            font-size: 12px;
            color: #ffffff;
            i {
              padding-right: 1px;
              &::before {
                font-size: 16px;
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/partial/customer/CustomerPix.vue